import { BaseModel } from "@blue-chip/core";

export default class Certification extends BaseModel {}
